const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const RoleApprovalCommand: any = {
    CreateRoleApprover: Backofficebff + '/v1/role-approval/role-approver',
    UpdateRoleApprover: Backofficebff + '/v1/role-approval/role-approver',
    DeleteRoleApprover: Backofficebff + '/v1/role-approval/role-approver',
    CreateUserRoleApprovalRequest: Backofficebff + '/v1/role-approval/request',
    ApproveRejectUserRoleRequest: Backofficebff + '/v1/role-approval/request/approve-reject',
    BulkApproveRejectUserRoleRequest: Backofficebff + '/v1/role-approval/request/bulk-approve-reject',
    UpdateRoleRequestability: Backofficebff + '/v1/role-approval/role/requestability',
};
